import * as React from 'react';

import XUIButton from '@xero/xui/react/button';
import XUIPicklist, { XUIPickitem } from '@xero/xui/react/picklist';
import XUIDropdown, { XUIDropdownToggled } from '@xero/xui/react/dropdown';

import './MultiselectPicklist.css';

interface IMultiselectPicklistProps {
    placeHolder: string;
    items: IMultiselectPicklistItem[];
    onSelect: (itemId: string) => void;
}

export interface IMultiselectPicklistItem {
    id: string;
    name: string;
    selected: boolean;
}

export default class MultiselectPicklist extends React.Component<IMultiselectPicklistProps> {
    constructor(props: IMultiselectPicklistProps) {
        super(props);
    }

    public render() {
        const { items } = this.props;

        const selectedItemNames = items.filter((item) => item.selected).map((item) => item.name);
        const trigger = (
            <XUIButton
                className='dropdown-trigger xui-font-size-medium xui-textcolor-standard xui-text-deemphasis xui-u-flex xui-u-flex-align-center xui-u-flex-justify-space-between'
                fullWidth='always'
                hasCaret={true}
            >
                {selectedItemNames.length === 0 ? this.props.placeHolder : selectedItemNames.join(', ')}
            </XUIButton>
        );
        const dropdown = (
            <XUIDropdown onSelect={this.props.onSelect}>
                <XUIPicklist>
                    {items.map((item) => (
                        <XUIPickitem
                            key={item.id}
                            id={item.id}
                            value={item.id}
                            isSelected={item.selected}
                            isMultiselect={true}
                        >
                            {item.name}
                        </XUIPickitem>
                    ))}
                </XUIPicklist>
            </XUIDropdown>
        );

        return <XUIDropdownToggled trigger={trigger} dropdown={dropdown} closeOnSelect={false} matchTriggerWidth={true} />;
    }
}
